import React from 'react'

import { SKELETON_ITEMS_COUNT } from 'shared/consts'

import './SkeletonLoader.scss'

const SkeletonLoader = () => (
  <>
    {[...Array(SKELETON_ITEMS_COUNT).keys()].map((index) => (
      <div key={index} className="skeleton">
        <div className="skeleton__avatar"></div>
        <div className="skeleton__body"></div>
      </div>
    ))}
  </>
)

export default SkeletonLoader
